    <div class="relative mb-3">
        <i class="pi pi-search pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400"></i>
        <input pInputText type="search"
               [(ngModel)]="searchTerm"
               class="w-full pl-10!"
               placeholder="Search" />
    </div>

    <div class="min-h-0 flex-1 overflow-y-auto pr-1">
        @if (loading) {
            <div class="flex h-full items-center justify-center text-sm text-gray-500">
                Loading chats...
            </div>
        } @else if (!filteredChats.length) {
            <div class="flex h-full flex-col items-center justify-center gap-3 text-center text-gray-500">
                <i class="pi pi-comments text-3xl"></i>
                <div class="text-sm">{{ hasActiveSearch() ? 'No chats have been found.' : 'No recent chats yet.' }}</div>
                @if (!hasActiveSearch()) {
                    <p-button label="New chat" icon="pi pi-plus" size="small" (onClick)="createChat.emit($event)" [loading]="creating" [disabled]="creating"></p-button>
                }
            </div>
        } @else {
            <div class="flex flex-col">
                @for (chat of filteredChats; track trackChat($index, chat)) {
                    <div role="button"
                         tabindex="0"
                         class="chat-row flex items-center w-full cursor-pointer justify-between rounded-sm gap-1 p-0.5 pl-1.5 text-left transition"
                         [ngClass]="chat.coso_chats_id === selectedChat?.coso_chats_id ? 'border-blue-300 bg-gray-100 dark:border-blue-400/40 dark:bg-gray-800/70' : 'border-gray-200 bg-white hover:bg-gray-100 dark:border-gray-700 dark:bg-transparent dark:hover:bg-gray-800/70'"
                         (click)="selectChat.emit(chat)"
                         (keydown)="onChatRowKeyDown($event, chat)">
                          <div class="flex min-w-0 flex-1 items-center gap-2">
                              <span class="material-symbols-outlined shrink-0 text-base! text-gray-400" aria-hidden="true">chat</span>
                              <div class="truncate text-sm">{{ chat.chat_title || 'Untitled chat' }}</div>
                          </div>
                          <div class="shrink-0">
                              <p-button icon="pi pi-ellipsis-v" [rounded]="true" [text]="true" severity="secondary"
                                        size="small"
                                        [loading]="deletingChatId === chat.coso_chats_id || renamingChatId === chat.coso_chats_id"
                                        [disabled]="deletingChatId === chat.coso_chats_id || renamingChatId === chat.coso_chats_id"
                                        (onClick)="openChatActions($event, chat, chatActionsMenu)"
                                        pTooltip="Chat actions" tooltipPosition="left" tooltipStyleClass="text-sm"
                                        showDelay="700"></p-button>
                              <p-menu #chatActionsMenu [model]="chatActionItems" [popup]="true" appendTo="body">
                                <ng-template #start>
                                  <div class="flex flex-col min-w-0 gap-1 p-3 border-b border-gray-200 dark:border-b-gray-700">
                                    <div class="flex min-w-0 items-center justify-between gap-2">
                                      <span class="truncate text-xs text-gray-500 dark:text-gray-300">{{ getConfigHint(chat) }}</span>
                                      <p-tag [value]="getLanguageLabel(chat)" severity="secondary" class="text-xs!"></p-tag>
                                    </div>
                                    <span class="text-xs text-gray-400">{{ getRelativeDate(chat) }}</span>
                                  </div>
                                </ng-template>
                              </p-menu>
                          </div>
                    </div>
                }
            </div>
        }
    </div>

    <p-dialog
            header="Rename chat"
            [(visible)]="renameDialogVisible"
            [modal]="true"
            [draggable]="false"
            [resizable]="false"
            [style]="{ width: 'min(420px, 94vw)' }"
            appendTo="body"
            (onHide)="closeRenameDialog()">
        <form class="flex flex-col gap-3" (ngSubmit)="submitRename()">
            <div class="flex flex-col gap-2">
                <label for="rename-chat-title" class="text-sm font-medium">Name</label>
                <input id="rename-chat-title"
                       type="text"
                       pInputText
                       name="renameTitle"
                       [(ngModel)]="renameTitle"
                       class="w-full"
                       autocomplete="off" />
            </div>
        </form>

        <ng-template #footer>
            <div class="flex justify-end gap-2">
                <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true"
                          (onClick)="closeRenameDialog()"></p-button>
                <p-button label="Save" icon="pi pi-save"
                          (onClick)="submitRename()"
                          [disabled]="!canRenameChat()"></p-button>
            </div>
        </ng-template>
    </p-dialog>
